<section class="works-mission">
  <div class="box-container">
    <div class="mission-topic">
      <!-- desktop and tablet heading -->
      <div
        class="mission-topic__heading mission-topic__heading--desktop color-white"
        [innerHtml]="'WORK_WITH_US.MISSION_SECTION.HEADING' | translate"
      >
      </div>
      <!-- mobile heading -->
      <div
        class="mission-topic__heading mission-topic__heading--mobile color-white"
        [innerHtml]="'WORK_WITH_US.MISSION_SECTION.HEADING_MOBILE' | translate"
      >
      </div>
    </div>

    <div class="box">
      <div class="box__slogan">
        <q [innerHtml]="'WORK_WITH_US.MISSION_SECTION.DETAIL' | translate"></q>
      </div>
    </div>
  </div>
</section>
